// removed by extract-text-webpack-plugin
module.exports = {"form":"_2vHCx6V","inputField":"_2ymGCRb","email":"_3mqFCby","button":"_2hLa0Yn","privacy":"_3PefUcf","privacyLink":"_2PODL4j","message":"_10887cu","thankYou":"_33B9gCp","createdIcon":"_2GxfoYG","createdSvg":"_1_Urv5b","createdMessage":"_15cE440"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SavePanel/components/JobMail/JobMail.less
 ** module id = 890
 ** module chunks = 0
 **/